import {
  EInvoiceUnitChildrenTypes,
  IInvoiceUnitDTO,
  IInvoiceUnitDTOChildren,
} from 'common/interfaces/invoices';
import {
  IEditablePackageConfiguration,
  IMembershipInvoicePackage,
  IServiceInvoicePackage,
} from 'common/interfaces/membership';

export const checkIsGracePeriodAllow = (
  packageItem: IEditablePackageConfiguration,
  isPaymentGraceAllow = false,
): boolean => {
  if (packageItem.paymentGrace?.allow || isPaymentGraceAllow) {
    return true;
  }

  let isAllow: boolean = isPaymentGraceAllow;

  for (const serviceItem of packageItem.services) {
    if (serviceItem.package !== null) {
      isAllow = checkIsGracePeriodAllow(serviceItem.package, isPaymentGraceAllow);
      break;
    }
  }

  return isAllow;
};

export const transformInvoiceServiceDTO = (
  service: IInvoiceUnitDTOChildren,
): IMembershipInvoicePackage | IServiceInvoicePackage => {
  return {
    ...service.bundle,
    subtotalDiscountAmount: service.subtotalDiscountAmount,
    // @ts-ignore
    feeSection: {
      fees: service.children.reduce((children, currentChilde) => {
        if (currentChilde.type === EInvoiceUnitChildrenTypes.PackageFee) {
          return [
            ...children,
            {
              ...currentChilde.packageFee,
              subtotalDiscountAmount: currentChilde.subtotalDiscountAmount,
            },
          ];
        }
        return children;
      }, []),
    },
    // @ts-ignore
    services: [
      ...service.bundle.services,
      ...service.children.reduce((children, currentChilde) => {
        if (currentChilde.type === EInvoiceUnitChildrenTypes.ServiceBundle) {
          return [...children, { package: transformInvoiceServiceDTO(currentChilde) }];
        }
        return children;
      }, []),
    ],
  };
};

export const transformInvoiceBundleDTO = (
  invoiceUnit: IInvoiceUnitDTO,
): IMembershipInvoicePackage | IServiceInvoicePackage => {
  return {
    ...invoiceUnit.bundle,
    fees: invoiceUnit.children.reduce((children, currentChilde) => {
      if (currentChilde.type === EInvoiceUnitChildrenTypes.PackageFee) {
        return [
          ...children,
          {
            ...currentChilde.packageFee,
            subtotalDiscountAmount: currentChilde.subtotalDiscountAmount,
          },
        ];
      }
      return children;
    }, []),
    // @ts-ignore
    services: [
      ...(invoiceUnit.bundle?.services ? invoiceUnit.bundle.services : []),
      ...invoiceUnit.children.reduce((children, currentChilde) => {
        if (currentChilde.type === EInvoiceUnitChildrenTypes.ServiceBundle) {
          return [...children, { package: transformInvoiceServiceDTO(currentChilde) }];
        }
        return children;
      }, []),
    ],
  };
};
